import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

const Gotanidea = ()=>{
    const navigate = useNavigate();

    return(
        <section className='gotanidea-contanier'>
                <div className='gotanidea-content-left'>
                    <p>Got an Idea?</p>
                    <h1>Let’s craft brilliance together!</h1> 
                </div>
                <div className="gotanidea-btn" onClick={() => navigate('/Contact-us')}>
                    Get in Touch →
                </div>
        </section>
    );
};

export default Gotanidea;